@if (addpolicy) {
<ng-template #addpolicy let-c="close" let-d="dismiss">
  <div class="modal-header d-flex flex-row justify-content-between">
    <div class="d-flex flex-row align-items-center modal-back" type="button" (click)="c('Cross click')">
      <button></button>
      <h3>{{ 'back' | translate }}</h3>
    </div>
    <h2 class="text-center">{{ 'security-policies-form-add-title' | translate }}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('Cross click')"></button>
  </div>
  <div class="modal-body d-flex flex-column align-items-center justify-content-center">
    <table class="table">
      <tbody>
        <tr>
          <td>
            <h4>{{ 'security-policies-form-add-policy-name' | translate }}</h4>
          </td>
          <td class="form">
            <div class="d-flex flex-column justify-content-center align-items-center block">
              <input class="form-control" [formControl]="getControl('policy-name')">
              @if (getControl('policy-name').invalid && getControl('policy-name').dirty) {
              <div class="alert alert-danger">
                @if (getControl('policy-name').errors?.['required']) {
                <div>
                  {{ 'security-policies-form-error-required' | translate }}
                </div>
                }
                @if (getControl('policy-name').errors?.['exist']) {
                <div>
                  {{ 'security-policies-form-error-already-exist' | translate }}
                </div>
                }
                @if (getControl('policy-name').errors?.['whitespace'] &&
                !getControl('policy-name').errors?.['required']) {
                <div>
                  {{ 'security-policies-form-error-invalid-value' | translate }}
                </div>
                }
                @if (getControl('policy-name').errors?.['minlength'] &&
                !getControl('policy-name').errors?.['whitespace'] && !getControl('policy-name').errors?.['required']) {
                <div>
                  {{ 'security-policies-form-error-minlength' | translate }}
                </div>
                }
              </div>
              }
            </div>
          </td>
        </tr>
        <tr>
          <td class="title">
            <div class="d-flex align-items-center">
              <h4>{{ 'security-policies-form-add-os' | translate }}</h4>
            </div>
          </td>
          <td class="form">
            <div class="d-flex align-items-center justify-content-center block">
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn" id="os" ngbDropdownToggle>
                  <img src="assets/icons/logosOS/{{form.value['os'].toLowerCase()}}.svg">
                  {{ form.value['os'] }}
                </button>
                <div class="d-flex justify-content-center block">
                  <div ngbDropdownMenu aria-labelledby="os">
                    @for (os of getAllOS(); track os) {
                    <button ngbDropdownItem (click)="setOs(os)">
                      <div class="d-flex flex-row align-items-center">
                        <img src="assets/icons/logosOS/{{os.toLowerCase()}}.svg">
                        <p>{{ os }}</p>
                      </div>
                    </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="title">
            <h4>{{ 'security-policies-form-add-bw' | translate }}</h4>
          </td>
          <td class="form">
            <div class="d-flex justify-content-center block">
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn" id="bwv" ngbDropdownToggle>
                  {{ form.value['BWVersion'] }}
                </button>
                <div ngbDropdownMenu aria-labelledby="bwv">
                  @for (v of lbwversion(); track v) {
                  <button ngbDropdownItem (click)="setBwv(v.version)">
                    {{ v.version }}
                  </button>
                  }
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr *kaHasRoles="['bo-dip-wl-admin']; checkRealm: true">
          <td class="title">
            <h4>{{ 'settings-clients-add-client-client' | translate }}</h4>
          </td>
          <td class="form">
            <div class="d-flex justify-content-center block">
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn" id="client" ngbDropdownToggle>
                  {{ form.value['client'] }}
                </button>
                <div ngbDropdownMenu aria-labelledby="client">
                  @for (cli of lclients(); track cli) {
                  <button ngbDropdownItem (click)="setClient(cli.name)">
                    {{ cli.name }}
                  </button>
                  }
                </div>
              </div>
            </div>
          </td>
        </tr>

      </tbody>
    </table>
    <button class="btn btn-outline-primary d-flex flex-row justify-content-center continue"
      [disabled]="getControl('policy-name').invalid" (click)="createNewPolicy(); openFullScreen({content: formpolicy})">
      {{ 'continue' | translate }}
      <img class="side-arrow" src="assets/icons/ComprReport/down-arrow.svg">
    </button>
  </div>
</ng-template>
<div class="addpolicy d-flex flex-row justify-content-center align-items-center" type="button"
  (click)="open({content : addpolicy})">
  <img src="assets/icons/Policies/add.svg">
  <p>{{ 'security-policies-simulation-add-policy' | translate }}</p>
</div>
}

@if (!addpolicy) {
<ng-template #simulate let-c="close" let-d="dismiss">
  <div class="modal-header d-flex flex-row justify-content-between">
    @if (!resultSimulation()) {
    <h2 class="text-center">{{ 'security-policies-form-simulation-title-1' | translate }}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('Cross click')"></button>
    }
    @if (resultSimulation()) {
    <h2 class="text-center">{{ 'security-policies-form-simulation-title-2' | translate }}</h2>
    <button type="button" class="modal-close" aria-label="Close" (click)="modaldismiss('close')"></button>
    }
  </div>
  @if (!resultSimulation()) {
  <div class="modal-body d-flex flex-column justify-content-center align-items-center">
    <table>
      <tbody>
        @if (lallPolicies) {
        <tr *kaHasRoles="['bo-dip-wl-admin']; checkRealm: true">
          <td class="title">
            <h4>{{ 'settings-clients-add-client-client' | translate }}</h4>
          </td>
          <td class="form">
            <div class="d-flex justify-content-center block">
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn" id="clientChoice" ngbDropdownToggle>
                  {{ form.value['client'] }}
                </button>
                <div ngbDropdownMenu aria-labelledby="clientChoice">
                  @for (cli of lclients(); track cli) {
                  <button ngbDropdownItem
                    (click)="setClient(cli.name); patchListPolicyByClients(cli.name, lallPolicies)">
                    {{ cli.name }}
                  </button>
                  }
                </div>
              </div>
            </div>
          </td>
        </tr>
        }
        <tr>
          <td>
            <h4>{{ 'security-policies-form-add-policy' | translate }}</h4>
          </td>
          <td *kaHasRoles="['bo-dip-wl-admin']; checkRealm: true" class="form">
            <div class="d-flex align-items-center justify-content-center block">
              @if (!policy) {
              <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn" id="policy" ngbDropdownToggle>
                  {{ findPolicy()?.name }}
                </button>
                <div class="d-flex justify-content-center block">
                  <div ngbDropdownMenu aria-labelledby="policy">
                    @for (pol of listPoliciesClientSelected(); track pol) {
                    <button ngbDropdownItem (click)="setPolicy(pol)">
                      <p>{{ pol.name }}</p>
                    </button>
                    }
                  </div>
                </div>
              </div>
              }
              @if (policy) {
              <button class="dropdown-toggle" [disabled]="true">
                {{ policy.name }}
              </button>
              }
            </div>
          </td>
        </tr>
        <tr>
          <td class="title">
            <h4>{{ 'security-policies-form-add-app' | translate }}</h4>
          </td>
          <td class="form">
            <div class="d-flex flex-column justify-content-center align-items-center block">
              <div class="d-flex align-items-center justify-content-center block">
                <div ngbDropdown class="d-inline-block">
                  <button type="button" class="btn" id="application" ngbDropdownToggle>
                    {{ findAppli()?.packageName }}
                  </button>
                  <div class="d-flex justify-content-center block">
                    <div ngbDropdownMenu aria-labelledby="application">
                      @for (app of lApplications(); track app) {
                      <div>
                        <button ngbDropdownItem (click)="setApp(app)">
                          {{ app.packageName }}
                        </button>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="title">
            <h4>{{ 'security-policies-form-add-date' | translate }}</h4>
          </td>
          <td class="form">
            <div class="date d-flex justify-content-center">
              <app-datepicker [stampdebut]="form.value['stampdebut']" [min_date]="min_date"
                [stampfin]="form.value['stampfin']" (myDatePicker)="setDate($event)">
              </app-datepicker>
            </div>
          </td>
        </tr>
        <tr>
          <td class="title">
            <h4>{{ 'security-policies-form-add-number' | translate }}</h4>
          </td>
          <td class="form">
            <div class="d-flex flex-column justify-content-around numberofatt">
              <div class="d-flex flex-row align-items-center justify-content-center">
                <mat-checkbox [(ngModel)]="range_disabled"></mat-checkbox>
                <p class="num">{{ formatNumber(number_value) }}</p>
              </div>
              <mat-slider min="0" max="1000000" step="10000" [disabled]="!range_disabled">
                <input matSliderThumb [(ngModel)]="number_value">
              </mat-slider>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    @if (!formSimulationError()) {
    <p class="error">{{ 'security-policies-form-error-nbordate' | translate }}</p>
    }
    <div class="d-flex flex-row justify-content-center">
      <button type="button" class="btn btn-outline-success" [disabled]="!formSimulationError()"
        (click)="requestSimulation()">{{ 'confirm' | translate }}</button>
    </div>
  </div>
  } @else {
  <app-simulation-results (close)="modaldismiss($event)" [requestParam]="resultSimulation()" [appSelected]="findAppli()"
    [policySelected]="findPolicy()"></app-simulation-results>
  }
</ng-template>
@if (!policy) {
<button [disabled]="(lallPolicies?.length ?? 0) < 1"
  class="btn btn-outline-primary d-flex flex-row justify-content-center simulb align-items-center"
  (click)="open({content : simulate})">
  <img src="assets/icons/ui.svg">
  {{ 'security-policies-simulation-create-simulation' | translate }}
</button>
}
@if (policy) {
<button [disabled]="disabledB"
  class="btn btn-outline-primary d-flex flex-row justify-content-center simulbd align-items-center"
  (click)="open({content : simulate})">
  <img src="assets/icons/ui.svg">
  {{ 'security-policies-details-button-simulate' | translate }}
</button>
}
}

<ng-template #formpolicy let-c="close" let-d="dismiss">
  @if (newPolicy) {
  <app-form-policy (editP)="addPolicySaved($event)" [policy]="newPolicy" [create]="true" [nameClient]="nameClient"
    (closeEvent)="modaldismiss($event)"></app-form-policy>
  }
</ng-template>